import React from 'react'
import { alpha, fade, makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import clsx from 'clsx'

const PulsedIcons = ({ label, color = PRIMARY_COLORS, children }) => {
  const useStyle = makeStyles(theme => ({
    rootDiv: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      right: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    iconDiv: {
      borderRadius: 100,
      border: '8px solid ' + color[100],
      backgroundColor: color[200],
      padding: '18px 19px',
      color: color[500]
    },
    typography: {
      color: GRAY_COLORS[800],
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '18px'
    },
    circle: {
      boxShadow: `0 0 0 ${alpha(color[500], 0.5)}`,
      animation: `$pulsing-danger 1500ms ${theme.transitions.easing.easeOut} infinite`
    },
    '@keyframes pulsing-danger': {
      '0%': {
        boxShadow: `0 0 0 0 ${alpha(color[500], 0.5)}`
      },
      '70%': {
        boxShadow: `0 0 0 50px ${alpha(color[500], 0.0)}`
      },
      '100%': {
        boxShadow: `0 0 0 0 ${alpha(color[500], 0.0)}`
      }
    }
  }))
  const classes = useStyle()

  return (
    <div className={classes.rootDiv}>
      <div className={clsx(classes.iconDiv, classes.circle)}>{children}</div>
      <div className={classes.typography}>{label}</div>
    </div>
  )
}

export default PulsedIcons
